import React, { FC } from 'react';
import classNames from 'classnames';

export enum HeaderSize {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
  HERO = 'hero',
}

export interface HeaderInterface {
  omitSizeString?: boolean;
  size:
    | HeaderSize.H1
    | HeaderSize.H2
    | HeaderSize.H3
    | HeaderSize.H4
    | HeaderSize.HERO;
  text: any;
  applyUpperCasing?: boolean;
  align?: 'left' | 'center' | 'right';
  classes?: string;
}

const sizeString = (size: HeaderSize): string => {
  return {
    h1: 'text-h1 md:text-d-h1',
    h2: 'text-h2 md:text-d-h2',
    h3: 'text-h3 md:text-d-h3',
    h4: 'text-h4 md:text-d-h4',
    hero: 'text-hero md:text-d-hero',
  }[size];
};

const HeaderText: FC<HeaderInterface> = ({
  omitSizeString,
  size = HeaderSize.H1,
  text,
  align,
  classes = '',
  applyUpperCasing,
}) => {
  if (!text) {
    return null;
  }

  const element = size == HeaderSize.HERO ? 'h1' : size;
  return React.createElement(
    element,
    {
      role: 'heading',
      className: classNames(
        align === 'center' ? 'title-container' : '',
        'font-bold w-full text-charcoal-v2',
        align && `text-${align}`,
        !omitSizeString ? sizeString(size) : '',
        applyUpperCasing ? 'uppercase' : '',
        classes,
      ),
      'data-testid': `text-headerText-${size}`,
    },
    text,
  );
};

export default React.memo(HeaderText);
